import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './FormButtons.css';


const FormButtons = ({ children, isTop, isMobile }) => (
  <div
    className={classNames({
      'form-buttons--top': isTop,
      'form-buttons--bottom': !isTop && !isMobile,
      'form-buttons--mobile': isMobile,
    }, 'form-buttons')}
  >
    {children}
  </div>
);

FormButtons.propTypes = {
  children: PropTypes.node,
  isTop: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default FormButtons;



// WEBPACK FOOTER //
// ./src/components/FormButtons/FormButtons.jsx